import { createContext, useContext } from 'react';
export const HDSFeaturesContext = /*#__PURE__*/createContext({});
export const useHDSFeaturesContext = () => {
  const features = useContext(HDSFeaturesContext);
  if (features === undefined) {
    throw new Error('useHDSFeaturesContext must be used within HDSAppProvider');
  }
  return features;
};
export const useNextThemeEnabled = () => {
  const {
    nextThemeEnabled
  } = useHDSFeaturesContext();
  return nextThemeEnabled || false;
};
export const useDarkColorSchemeEnabled = () => {
  const features = useHDSFeaturesContext();
  if (!features.nextThemeEnabled) {
    return false;
  } else {
    return features.darkColorSchemeEnabled || false;
  }
};